var map = {
	"./clone": 161,
	"./clone.js": 161,
	"./contexts/context": 117,
	"./contexts/context.js": 117,
	"./contexts/diff": 118,
	"./contexts/diff.js": 118,
	"./contexts/patch": 119,
	"./contexts/patch.js": 119,
	"./contexts/reverse": 120,
	"./contexts/reverse.js": 120,
	"./date-reviver": 217,
	"./date-reviver.js": 217,
	"./diffpatcher": 218,
	"./diffpatcher.js": 218,
	"./environment": 121,
	"./environment.js": 121,
	"./filters/arrays": 219,
	"./filters/arrays.js": 219,
	"./filters/dates": 220,
	"./filters/dates.js": 220,
	"./filters/lcs": 221,
	"./filters/lcs.js": 221,
	"./filters/nested": 222,
	"./filters/nested.js": 222,
	"./filters/texts": 223,
	"./filters/texts.js": 223,
	"./filters/trivial": 224,
	"./filters/trivial.js": 224,
	"./formatters/annotated": 122,
	"./formatters/annotated.js": 122,
	"./formatters/base": 59,
	"./formatters/base.js": 59,
	"./formatters/console": 162,
	"./formatters/console.js": 162,
	"./formatters/html": 123,
	"./formatters/html.js": 123,
	"./formatters/index": 124,
	"./formatters/index.js": 124,
	"./formatters/jsonpatch": 125,
	"./formatters/jsonpatch.js": 125,
	"./main": 126,
	"./main-formatters": 325,
	"./main-formatters.js": 325,
	"./main-full": 326,
	"./main-full.js": 326,
	"./main.js": 126,
	"./pipe": 163,
	"./pipe.js": 163,
	"./processor": 225,
	"./processor.js": 225
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 324;



/*****************
 ** WEBPACK FOOTER
 ** ./~/jsondiffpatch/src ^\.\/.*$
 ** module id = 324
 ** module chunks = 0
 **/